import { render, staticRenderFns } from "./MyAffiliateRegistrationRequest.vue?vue&type=template&id=f959bee4"
import script from "./MyAffiliateRegistrationRequest.vue?vue&type=script&lang=ts"
export * from "./MyAffiliateRegistrationRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports